import type { ApiConfig } from '../../types'

export const usdFutureHistoryApiConfig = {
  existSubType: false,
  fetchableRange: 3 * 30 * 24 * 60 * 60 * 1000, // 3 months in milliseconds
  limit: 1000,
  order: 'asc',
  range: 7 * 24 * 60 * 60 * 1000, // 7 days in milliseconds
  requiresRange: true,
  type: 'usd-future-history',
} as const satisfies ApiConfig
